import React from 'react';

import { config } from './constants';
import { Level } from './types';

type Props = {
  level: Level;
};

export const Icon: React.FC<Props> = ({ level }) => {
  const { RawIcon, iconClassnames } = config[level];

  return (
    <span className={`shrink-0 flex items-center w-lg h-lg ${iconClassnames}`}>
      <RawIcon />
    </span>
  );
};
